export default __webpack_public_path__ + "static/media/react.3264355e.jpg";